import list from './list'
import create from './create'
import update from './update'
import show from './show'
import del from './delete'
import createModal from './createModal'
import createMultipleTaskModal from './createMultipleTaskModal'

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    createModal,
    createMultipleTaskModal
  }
}
